module.exports = __webpack_public_path__ + "static/media/AdsIconActive.c7ed3e06.svg";